import { render, staticRenderFns } from "./RipaSwitch.vue?vue&type=template&id=de686e40"
import script from "./RipaSwitch.vue?vue&type=script&lang=js"
export * from "./RipaSwitch.vue?vue&type=script&lang=js"
import style0 from "./RipaSwitch.vue?vue&type=style&index=0&id=de686e40&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports